import { Badge } from "@/components/ui/badge";
import { CreditCard, PlugZap, Rocket, UserPlus } from "lucide-react";

const STEPS = [
    { Icon: UserPlus, title: "Choisissez votre SaaS", desc: "Sélectionnez les outils de la suite qui répondent à vos besoins du moment. Mixez selon votre stack." },
    { Icon: CreditCard, title: "Souscription en ligne", desc: "Quelques clics, paiement sécurisé, accès immédiat. Sans engagement et sans rendez-vous commercial forcé." },
    { Icon: PlugZap, title: "Onboarding éclair", desc: "Connectez vos comptes Google, Plesk ou votre numéro SMS en moins de 5 minutes — interfaces guidées." },
    { Icon: Rocket, title: "Encaissez les gains", desc: "Vos collaborateurs gagnent du temps, vos clients voient les résultats, votre CA suit. C'est tout." },
];

export default function HowItWorksSection() {
    return (
        <section id="process" className="relative border-t border-border py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-4 sm:px-6">
                <div className="mx-auto max-w-3xl text-center">
                    <Badge variant="outline" className="rounded-full border-border bg-card/60 px-3 py-1 text-xs text-muted-foreground">
                        Comment ça marche
                    </Badge>
                    <h2 className="mt-4 font-display text-3xl font-semibold leading-tight tracking-tight text-foreground sm:text-4xl lg:text-5xl">
                        De la curiosité au<br />
                        <span className="text-gradient">premier résultat en 24h.</span>
                    </h2>
                </div>

                <div className="relative mt-16">
                    <div className="absolute left-0 right-0 top-9 hidden h-px bg-gradient-to-r from-transparent via-border to-transparent lg:block" />
                    <div className="grid gap-6 lg:grid-cols-4">
                        {STEPS.map((s, i) => (
                            <div key={s.title} className="relative flex flex-col">
                                <div className="relative flex h-[72px] items-center justify-center">
                                    <div className="flex h-[72px] w-[72px] items-center justify-center rounded-2xl border border-border bg-card shadow-card-elevated">
                                        <s.Icon className="h-7 w-7 text-primary" />
                                    </div>
                                    <span className="absolute -right-1 -top-1 flex h-6 w-6 items-center justify-center rounded-full bg-gradient-primary font-mono text-[10px] font-bold text-primary-foreground">
                                        {String(i + 1).padStart(2, "0")}
                                    </span>
                                </div>
                                <h3 className="mt-5 font-display text-lg font-semibold text-foreground">{s.title}</h3>
                                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{s.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
